import { GET_EVENTS, GET_EVENTS_SUCCESS, GET_EVENTS_FAILURE } from "../constants"

const INIT_STATE = {
    events: false,
    fetching: false,
    error: false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_EVENTS:
            return { ...state, fetching: true, error: false }

        case GET_EVENTS_SUCCESS:
            return { ...state, fetching: false, error: false, events: action.payload.events }

        case GET_EVENTS_FAILURE:
            return { ...state, fetching: false, error: action.payload.err }

        default:
            return { ...state }
    }
}